<table class="w-full">
  @if (config.caption) {
    <caption>{{ config.caption }}</caption>
  }

  <thead>
    <tr>
      @if (config.selectMultiple) {
        <th class="w-32 p-6">
          <div
            class="group relative flex items-center text-xs/[14px] text-[#f8f8f8] transition-[color] duration-250 ease-in-out px-4 py-2"
            tabindex="0"
            aria-hidden="true"
            (click)="$event.stopPropagation(); toggleAllItemsIsSelected();"
          >
            <span
              class="flex justify-center items-center mr-2 w-5 h-5 bg-transparent
                border-solid rounded-sm cursor-pointer
                transition-all duration-250 ease-in-out
                group-[]:bg-transparent"
              [ngClass]="{
                'border-1 border-gray-400': !isEveryPageItemSelectedSig() && !isSomeButNotEveryPageItemSelectedSig(),
                'border-10 animate-shrink-bounce before:content-[\'\'] before:absolute before:border-b-1.5 before:border-b-solid': isSomeButNotEveryPageItemSelectedSig() || isEveryPageItemSelectedSig(),
                'border-[#454545] before:top-3 before:w-2 before:h-2 before:border-b-[#fefefe]': isSomeButNotEveryPageItemSelectedSig(),
                'border-cyan before:top-5 before:left-5 before:border-r-1.5 before:border-r-solid before:border-r-transparent before:border-b-transparent before:rotate-45 before:origin-bottom-left before:animate-checkbox-check': isEveryPageItemSelectedSig()
              }"
            ></span>
          </div>
        </th>
      }

      @for (column of config.columns; track $index) {
        <th class="text-[#adadad] text-base text-left font-semibold tracking-wide uppercase p-6">
          <div class="flex space-x-3" [ngClass]="{
            'justify-start': !column.align || column.align === 'left',
            'justify-center': column.align === 'center',
            'justify-end': column.align === 'right'
          }">
            <span>{{ column.label }}</span>

            <div class="flex items-center space-x-2 group">
              <nrc-icon
                class="w-4 h-4 opacity-0 group-hover:opacity-50 hover:!opacity-100 transition-opacity"
                [ngClass]="{
                  'opacity-50': column.orderBy === 'desc',
                  '!opacity-100': column.orderBy === 'asc'
                }"
                [fillColor]="column.orderBy === 'asc' ? 'cyan' : 'white'"
                [name]="'arrow-sharp-down'"
                (click)="orderByColumn(column, 'asc')"
              />

              <nrc-icon
                class="w-4 h-4 rotate-180 opacity-0 group-hover:opacity-50 hover:!opacity-100 transition-opacity"
                [ngClass]="{
                  'opacity-50': column.orderBy === 'asc',
                  '!opacity-100': column.orderBy === 'desc'
                }"
                [fillColor]="column.orderBy === 'desc' ? 'cyan' : 'white'"
                [name]="'arrow-sharp-down'"
                (click)="orderByColumn(column, 'desc')"
              />
            </div>
          </div>
        </th>
      }

      @if (config.itemActionButtons) {
        <th class="text-[#adadad] text-base text-center font-semibold tracking-wide uppercase p-6">
          ACTIONS
        </th>
      }
    </tr>
  </thead>

  <tbody>
    @for (item of items(); track rowIndex; let rowIndex = $index) {
      <tr class="border-solid cursor-pointer group hover:bg-white/5 border-y-1 border-white/10 -z-10 last:border-b-0">
        <!-- A checkbox for selecting the item in the list -->
        @if (config.selectMultiple) {
          <td class="w-32 p-6">
            <div
              class="group relative flex items-center text-xs/[14px] text-[#f8f8f8] transition-[color] duration-250 ease-in-out px-4 py-2"
              tabindex="0"
              aria-hidden="true"
              (click)="$event.stopPropagation(); toggleItemIsSelectedAtIndex(rowIndex);"
            >
              <span
                class="flex justify-center items-center mr-2 w-5 h-5 bg-transparent
                  border-solid rounded-sm cursor-pointer
                  transition-all duration-250 ease-in-out
                  group-[]:bg-transparent"
                [ngClass]="{
                  'border-1 border-gray-400': !item.isSelected,
                  'border-10 border-cyan animate-shrink-bounce before:content-[\'\'] before:absolute before:top-5 before:left-5 before:border-r-1.5 before:border-r-solid before:border-r-transparent before:border-b-1.5 before:border-b-solid before:border-b-transparent before:rotate-45 before:origin-bottom-left before:animate-checkbox-check': item.isSelected
                }"
              ></span>
            </div>
          </td>
        }

        @for (column of config.columns; track itemIndex; let itemIndex = $index) {
          <td class="p-6" tabindex="0" (click)="rowClickedEvent.emit({ index: rowIndex, item })" (keydown)="null">
            <nrc-row-list-item
              class="flex"
              [ngClass]="{
                'justify-start': !column.align || column.align === 'left',
                'justify-center mr-13': column.align === 'center',
                'justify-end': column.align === 'right'
              }"
              [index]="rowIndex"
              [isSelected]="item.isSelected"
              [config]="{
                type: column.type,
                value: item.value | extractProperty: column.key,
                additionalInfo: column['additionalInfoKey'] ? (item.value | extractProperty: (column['additionalInfoKey'] | toString)) : undefined,
                thumbnailConfig: column.thumbnailConfig,
                mimetype: column.thumbnailConfig && column.thumbnailConfig.thumbnailSourceKey && (item.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                  ? 'image/png'
                  : (item.value | extractProperty: (column.thumbnailConfig?.fallbackMimetypeKey | toString) | toString),
                thumbnailSource: column.thumbnailConfig && column.thumbnailConfig.thumbnailSourceKey
                  ? (item.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                    ? (item.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                    : (item.value | extractProperty: (column.thumbnailConfig.fallbackThumbnailSourceKey | toString) | toString)
                  : undefined,
                userData: column.key === 'createdAt' || column.key === 'updatedAt' ? {
                  id: (item.value | extractProperty: (column['userData']['idPropertyKey'] | toString)) | toString,
                  profileColor: (item.value | extractProperty: (column['userData']['profileColorKey'] | toString)) | toString,
                  firstName: (item.value | extractProperty: (column['userData']['firstNameKey'] | toString)) | toString,
                  lastName: (item.value | extractProperty: (column['userData']['lastNameKey'] | toString)) | toString,
                  roleName: (item.value | extractProperty: (column['userData']['roleNameKey'] | toString)) | toString,
                } : undefined,
                isHighlighted: column.isHighlighted,
                actionRole: item.actionRole,
                tooltipText: column['tooltipText'],
                extractorFn: column['extractorFn'],
                tooltipTextFn: column['tooltipTextFn'],
                visibilityFn: column['visibilityFn'],
                hasChildren: hasChildren(item),
                isCollapsed: isCollapsed(item)
              }"
              (rowListItemClickedEvent)="rowClickedEvent.emit({ index: rowIndex, itemIndex, item })"
              (toggleCollapseEvent)="toggleRowCollapse(item, rowIndex)"
            />
          </td>
        }

        <!-- Action buttons for each item -->
        @if (config.itemActionButtons && config.itemActionButtons.length > 0) {
          <td class="p-6">
            <div class="flex items-center justify-center visible space-x-3 md:invisible md:group-hover:visible">
              @for (actionButton of config.itemActionButtons; track $index) {
                @if (!actionButton.visibilityFn || actionButton.visibilityFn(item.value)) {
                  <nrc-button
                    class="relative w-10 h-10"
                    [icon]="actionButton?.icon"
                    [label]="actionButton?.label"
                    [buttonType]="actionButton?.buttonType"
                    [role]="actionButton?.role"
                    [tooltipText]="actionButton?.tooltipText"
                    (clickEvent)="itemActionButtonEvent.emit({ value: item, actionButton, index: rowIndex })"
                  />
                }
              }
            </div>
          </td>
        }
      </tr>

      <!-- Child rows - rendered when parent is expanded -->
      @if (config.collapsibleRows && hasChildren(item) && !isCollapsed(item)) {
        <!-- Handle direct children array -->
        @if (item.childItems && item.childItems.length > 0) {
          @for (childItem of item.childItems; track childIndex; let childIndex = $index) {
            <tr class="border-solid cursor-pointer group hover:bg-white/5 border-y-1 border-white/10 -z-10 last:border-b-0 bg-white/[0.03] border-l-4 border-l-cyan/25">
              <!-- Indent for child items -->
              <td class="w-10 p-1">
                <div class="w-5 ml-4"></div>
              </td>

              @for (column of config.columns; track itemIndex; let itemIndex = $index) {
                <td class="p-6" tabindex="0" (click)="rowClickedEvent.emit({ index: childIndex, item: childItem })" (keydown)="null">
                  <nrc-row-list-item
                    class="flex"
                    [ngClass]="{
                      'justify-start': !column.align || column.align === 'left',
                      'justify-center mr-13': column.align === 'center',
                      'justify-end': column.align === 'right'
                    }"
                    [index]="childIndex"
                    [isSelected]="childItem.isSelected"
                    [config]="{
                      type: column.type,
                      value: childItem.value | extractProperty: column.key,
                      additionalInfo: column['additionalInfoKey'] ? (childItem.value | extractProperty: (column['additionalInfoKey'] | toString)) : undefined,
                      thumbnailConfig: column.thumbnailConfig,
                      mimetype: column.thumbnailConfig && column.thumbnailConfig.thumbnailSourceKey && (childItem.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                        ? 'image/png'
                        : (childItem.value | extractProperty: (column.thumbnailConfig?.fallbackMimetypeKey | toString) | toString),
                      thumbnailSource: column.thumbnailConfig && column.thumbnailConfig.thumbnailSourceKey
                        ? (childItem.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                          ? (childItem.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                          : (childItem.value | extractProperty: (column.thumbnailConfig.fallbackThumbnailSourceKey | toString) | toString)
                        : undefined,
                      userData: column.key === 'createdAt' || column.key === 'updatedAt' ? {
                        id: (childItem.value | extractProperty: (column['userData']['idPropertyKey'] | toString)) | toString,
                        profileColor: (childItem.value | extractProperty: (column['userData']['profileColorKey'] | toString)) | toString,
                        firstName: (childItem.value | extractProperty: (column['userData']['firstNameKey'] | toString)) | toString,
                        lastName: (childItem.value | extractProperty: (column['userData']['lastNameKey'] | toString)) | toString,
                        roleName: (childItem.value | extractProperty: (column['userData']['roleNameKey'] | toString)) | toString,
                      } : undefined,
                      isHighlighted: column.isHighlighted,
                      actionRole: childItem.actionRole,
                      tooltipText: column['tooltipText'],
                      extractorFn: column['extractorFn'],
                      tooltipTextFn: column['tooltipTextFn'],
                      visibilityFn: column['visibilityFn']
                    }"
                    (rowListItemClickedEvent)="rowClickedEvent.emit({ index: childIndex, itemIndex, item: childItem })"
                  />
                </td>
              }

              @if (config.itemActionButtons && config.itemActionButtons.length > 0) {
                <td class="p-6">
                  <div class="flex items-center justify-center visible space-x-3 md:invisible md:group-hover:visible">
                    @for (actionButton of config.itemActionButtons; track $index) {
                      @if (!actionButton.visibilityFn || actionButton.visibilityFn(childItem.value)) {
                        <nrc-button
                          class="relative w-10 h-10"
                          [icon]="actionButton?.icon"
                          [label]="actionButton?.label"
                          [buttonType]="actionButton?.buttonType"
                          [role]="actionButton?.role"
                          [tooltipText]="actionButton?.tooltipText"
                          (clickEvent)="itemActionButtonEvent.emit({ value: childItem, actionButton, index: childIndex })"
                        />
                      }
                    }
                  </div>
                </td>
              }
            </tr>
          }
        }
        <!-- Handle children in item.value object using the childrenKey -->
        @if (item.value && config.collapsibleConfig && config.collapsibleConfig.childrenKey) {
          @if ((item.value | extractProperty: (config.collapsibleConfig.childrenKey | toString)) && (item.value | extractProperty: (config.collapsibleConfig.childrenKey | toString)) | isNonEmptyArray) {
            @for (childItem of (item.value | extractProperty: (config.collapsibleConfig.childrenKey | toString) | toArray); track childIndex; let childIndex = $index) {
              <tr class="border-solid cursor-pointer group hover:bg-white/5 border-y-1 border-white/10 -z-10 last:border-b-0 bg-white/[0.03] border-l-4 border-l-cyan/25">
                <!-- Indent for child items -->
                <td class="w-10 p-1">
                  <div class="w-5 ml-4"></div>
                </td>

                @for (column of config.columns; track itemIndex; let itemIndex = $index) {
                  <td class="p-6" tabindex="0" (click)="rowClickedEvent.emit({ index: childIndex, item: { value: childItem } })" (keydown)="null">
                    <nrc-row-list-item
                      class="flex"
                      [ngClass]="{
                        'justify-start': !column.align || column.align === 'left',
                        'justify-center mr-13': column.align === 'center',
                        'justify-end': column.align === 'right'
                      }"
                      [index]="childIndex"
                      [config]="{
                        type: column.type,
                        value: childItem | extractProperty: (column.key | toString),
                        additionalInfo: column['additionalInfoKey'] ? (childItem | extractProperty: (column['additionalInfoKey'] | toString)) : undefined,
                        isHighlighted: column.isHighlighted,
                        actionRole: actionRole.PRIMARY,
                        tooltipText: column['tooltipText'],
                        extractorFn: column['extractorFn'],
                        tooltipTextFn: column['tooltipTextFn'],
                        visibilityFn: column['visibilityFn']
                      }"
                      (rowListItemClickedEvent)="rowClickedEvent.emit({ index: childIndex, itemIndex, item: { value: childItem } })"
                    />
                  </td>
                }
              </tr>
            }
          }
        }
      }
    }
  </tbody>
</table>
